import { Grid } from '@kirz/mui-admin';
import { Typography } from '@mui/material';
import React from 'react';

import { StepWrapper } from '../StepWrapper';

export default function Step() {
  return (
    <StepWrapper name="">
      <Grid container spacing={2} justifyContent="center">
        <Grid xs={12} sx={{ pt: 10 }}>
          <Typography variant="h6" align="center">
            Bedankt! Uw document is succesvol verzonden
          </Typography>
        </Grid>
      </Grid>
    </StepWrapper>
  );
}
